/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { campaignAclIndex } from '../../axios/campaignAclIndex'
import type {
	CampaignAclIndexError,
	CampaignAclIndexPathParams,
	CampaignAclIndexQueryParams,
	CampaignAclIndexResponse,
} from '../../types/CampaignAclIndex'

export const campaignAclIndexQueryKey = (
	campaign: CampaignAclIndexPathParams['campaign'],
	params?: CampaignAclIndexQueryParams,
) => [{ url: '/campaigns/:campaign/access', params: { campaign } }, ...(params ? [params] : [])] as const

export type CampaignAclIndexQueryKey = ReturnType<typeof campaignAclIndexQueryKey>

/** @see backend/nexus/modules/Campaign/Http/Controllers/CampaignAclController.php CampaignAclController::index */
export function campaignAclIndexQueryOptions(
	campaign: CampaignAclIndexPathParams['campaign'],
	params?: CampaignAclIndexQueryParams,
	config?: AxiosRequestConfig,
) {
	return queryOptions<
		CampaignAclIndexResponse,
		AxiosError<CampaignAclIndexError>,
		CampaignAclIndexResponse,
		CampaignAclIndexQueryKey
	>({
		queryKey: campaignAclIndexQueryKey(campaign, params),
		queryFn: ({ signal }) => campaignAclIndex(campaign, params, { signal, ...config }).then(res => res.data),
		enabled: !!campaign,
	})
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/CampaignAclController.php CampaignAclController::index */
export function useCampaignAclIndex<TSelectData = CampaignAclIndexResponse>(
	campaign: CampaignAclIndexPathParams['campaign'],
	params?: CampaignAclIndexQueryParams,
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					CampaignAclIndexResponse,
					AxiosError<CampaignAclIndexError>,
					TSelectData,
					CampaignAclIndexQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<CampaignAclIndexError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...campaignAclIndexQueryOptions(campaign, params),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/CampaignAclController.php CampaignAclController::index */
export function useCampaignAclIndexSuspense<TSelectData = CampaignAclIndexResponse>(
	campaign: CampaignAclIndexPathParams['campaign'],
	params?: CampaignAclIndexQueryParams,
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					CampaignAclIndexResponse,
					AxiosError<CampaignAclIndexError>,
					TSelectData,
					CampaignAclIndexQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<CampaignAclIndexError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...campaignAclIndexQueryOptions(campaign, params),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
